import { STATE_IDENTIFIER } from "./constants";

const { NUM_TASK, NUM_APPROVAL, NOTIFY_MSG } = STATE_IDENTIFIER;

const emptyState = {
  [NUM_TASK]: 0,
  [NUM_APPROVAL]: 0,
  [NOTIFY_MSG]: [],
};

export default emptyState;
